import { contactBanner, footer } from '../../../config/appData';
import './ContactUsBanner.css';

function ContactUsBanner({ onEnquireClick }) {
  const { contact } = footer;
  const { headline, subline, ctaText, ctaAriaLabel, orText, phoneLabel, emailLabel } = contactBanner;

  return (
    <section className="contact-us-banner" aria-labelledby="contact-banner-heading">
      <div className="contact-us-banner__inner">
        <div className="contact-us-banner__glow" aria-hidden="true" />
        <h2 id="contact-banner-heading" className="contact-us-banner__headline">
          {headline}
        </h2>
        <p className="contact-us-banner__subline">{subline}</p>
        <div className="contact-us-banner__actions">
          <button
            type="button"
            className="contact-us-banner__cta"
            onClick={onEnquireClick}
            aria-label={ctaAriaLabel}
          >
            <span className="contact-us-banner__cta-text">{ctaText}</span>
            <svg className="contact-us-banner__cta-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </button>
          <p className="contact-us-banner__or">{orText}</p>
          <div className="contact-us-banner__direct">
            <a href={`tel:${contact.phone.replace(/\s/g, '')}`} className="contact-us-banner__link">
              <span className="contact-us-banner__link-icon" aria-hidden="true">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
              </span>
              <span className="contact-us-banner__link-label">{phoneLabel}</span>
              <span className="contact-us-banner__link-value">{contact.phone}</span>
            </a>
            <a href={`mailto:${contact.email}`} className="contact-us-banner__link">
              <span className="contact-us-banner__link-icon" aria-hidden="true">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
              </span>
              <span className="contact-us-banner__link-label">{emailLabel}</span>
              <span className="contact-us-banner__link-value">{contact.email}</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactUsBanner;
